<template>
<div class="login-right-style">
  <div class="clearfix">
    <i class="iconfont iconarrowleft bind-back" @click="back"></i>
    <div class="code-group floatL">
      <h1 class="header-title">忘记密码</h1>
      <div class="header-nav"></div>
    </div>
  </div>
  <el-form :model="info" :rules="rules" ref="forgetForm">
    <el-form-item class="login-form-item" prop="account">
      <i class="iconfont iconzhanghao login-form-icon"></i>
      <el-input placeholder="请输入手机号" class="login-form-input" v-model="info.account" clearable />
    </el-form-item>
    <el-form-item class="login-form-item" prop="sms_code">
      <i class="iconfont iconyanzhengma1 login-form-icon"></i>
      <el-input placeholder="请输入验证码" class="login-form-input" v-model="info.sms_code" maxlength="4" clearable />
      <a class="getCode" @click="getCode" v-if="intervalNum == 60">获取验证码</a>
      <span class="wait-get-code" v-else>{{intervalNum}}秒后重新获取</span>
    </el-form-item>
    <el-form-item class="login-form-item" prop="new_pwd">
      <i class="iconfont iconxinmima login-form-icon"></i>
      <el-input placeholder="请输入新密码" class="login-form-input" :type="isShowPsd ? 'text' : 'password'" v-model="info.new_pwd" clearable />
      <i class="iconfont icon-eyes" :class="isShowPsd ? 'iconkejian' : 'iconbukejian1'" @click="isShowPsd = !isShowPsd"></i>
    </el-form-item>
    <el-form-item class="login-form-item" prop="password_repeat">
      <i class="iconfont iconsuo login-form-icon"></i>
      <el-input placeholder="请再次输入新密码" class="login-form-input" :type="isShowPsdAgin ? 'text' : 'password'" v-model="info.password_repeat" clearable />
      <i class="iconfont icon-eyes" :class="isShowPsdAgin ? 'iconkejian' : 'iconbukejian1'" @click="isShowPsdAgin = !isShowPsdAgin"></i>
    </el-form-item>
    <el-button class="login-btn" style="margin-top: 40px;margin-bottom: 30px;" @click="changePsd" :loading="isUpdating">更换密码</el-button>
  </el-form>
</div>
</template>
<script>
import {validateMobile, validatePassword, validateMobileReg} from '@/utils/validate';
import {sendResetCode, resetPassword} from '@/api/login';
export default{
  name: 'forgetComp',
  data () {
    return {
      info: {
        account: '',
        sms_code: '',
        new_pwd: '',
        password_repeat: ''
      },
      rules: {
        account: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {validator: validateMobile, trigger: 'blur', name: '手机号'}
        ],
        sms_code: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ],
        new_pwd: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {validator: validatePassword, result: '密码', trigger: 'blur'}
        ],
        password_repeat: [
          {required: true, message: '请输入确认密码', trigger: 'blur'},
          {validator: validatePassword, result: '确认密码', compareData: this.compareData, trigger: 'blur'}
        ]
      },
      intervalNum: 60,
      isUpdating: false,
      isShowPsdAgin: false,
      isShowPsd: false
    }
  },
  created() {
    this.generateScript();
  },
  methods: {
    // 密码校验
    compareData () {
      return this.info.new_pwd === this.info.password_repeat;
    },
    getCode () {
      this.$refs?.forgetForm?.validateField?.('account', async (isvalid) => {
        if (isvalid !== '') return null;
        this.openSliderVerify();
      })
    },
    generateScript () {
      // 判断是否已经引入js
      try {
        if (TencentCaptcha) return null;
      } catch (err) {
        const script = document.createElement('script');
        script.src = "https://turing.captcha.qcloud.com/TCaptcha.js";
        $('body').append($(script));
      }
    },
    openSliderVerify () {
      const _this = this;
      const captcha = new TencentCaptcha('2083949051',(res) => {
        // 用户确认但是客户端出现问题
        if (res.ret === 0 && res.errorCode) {
          this.$message.error(res.errorMessage);
        } else if (res.ret === 0) {
          // 用户校验成功
          _this.sendCode(res);
        }
      }, {
        needFeedBack: false
      })
      captcha.show();
    },
    // 发送验证码
    async sendCode (data) {
      try {
        await sendResetCode({
          account: this.info.account,
          captcha_ticket: data.ticket,
          captcha_rand_str: data.randstr
        })
        this.$message.success('验证码发送成功');
        this.intervalNum -= 1;
        this.interval = setInterval(() => {
          if (this.intervalNum <= 1) {
            clearInterval(this.interval);
            this.intervalNum = 60;
            return null;
          }
          this.intervalNum -= 1;
        }, 1000);
      } catch (err) {
        this.$message.error(err.msg || '获取数据失败，请重试');
      }
    },
    changePsd () {
      this.$refs?.forgetForm?.validate?.(async valid => {
        if (!valid) return null;
        this.isUpdating = true;
        try {
          await resetPassword(this.info);
          this.$message.success('重置密码成功');
          this.$emit('toggle', {type: 0});
        } catch (err) {
          this.$message.error(err.msg || '获取数据失败，请重试');
        } finally {
          this.isUpdating = false;
        }
      })
    },
    back () {
      this.$emit('toggle', {type: 0});
    }
  },
}
</script>
<style lang="less">
.bind-back{
  cursor: pointer;
  color: #333;
  font-weight: bold;
  float: left;
  display: block;
  margin-top: 6px;
  font-size: 18px;
  margin-right: 10px;
  &:hover{
    color: #3468FA;
  }
}
.getCode{
  color: #3468FA;
  font-size: 14px;
  margin-right: 20px;
  cursor: pointer;
  user-select: none;
}
.wait-get-code{
  user-select: none;
  color: #999;
  font-size: 14px;
  margin-right: 20px;
}
</style>